import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
//import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { TimezonePickerModule } from 'ng2-timezone-selector';

import {
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDialogModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
  MatStepperModule,
} from '@angular/material';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { AppComponent } from './app.component';
import { FooterModule } from './shared/footer/footer.module';
import { FixedpluginModule } from './shared/fixedplugin/fixedplugin.module';
import { AppRoutes } from './app.routing';
import { CoreModule } from './core/core.module';
import { Globals } from './globals';
import { ComponentsModule } from './components/components.module';
import { DateFormatting } from './providers/date-formatting';
import { NumberFormatting } from './providers/number-formatting';
import { ObjectTransformations } from './providers/object-transformations';
import { TablesDotNet } from './providers/tables-dot-net';
import { DatePipe } from '@angular/common';
import { GlobalService } from 'app/services/global/global.service';
import { CommunicationService } from './services/communication/communication.service';
import { PrivacyPolicy } from './pages/public/privacy-policy/privacy-policy.component';
import { PrivacyPolicyWhiteLabel } from './pages/public/privacy-policy-whitelabel/privacy-policy-whitelabel.component';
import { PrivacyPolicyUsa } from './pages/public/privacy-policy-usa/privacy-policy-usa.component';
import { TermsAndConditionsUsa } from './pages/public/terms-and-conditions-usa/terms-and-conditions-usa.component';



//import { AngularFirestoreModule } from '@angular/fire/firestore';
import { PaymentComponent } from './pages/public/payment/payment.component';
import { PaymentCompletedComponent } from './pages/public/payment-completed/payment-completed.component';
//import { UserService } from './services/user/user.service';
import { ExportService } from './services/export/export.service';
import { ClientService } from './services/client/client.service';
import { LocationService } from './services/location/location.service';
import { TwilioService } from './services/twilio/twilio.service';
import { ResponseServiceService } from './services/response-service/response-service.firebase.service';
import { UploadService } from './services/upload/upload.service';
import { PromoCodeComponent } from './pages/public/promo-code/promo-code.component';
import { GroupShareComponent } from './pages/public/group-share-code/group-share-code.component';
import { IntercomComponent } from './pages/public/intercom/intercom.component';
import { IntercomModule } from 'ng-intercom';
import { CustomClientService } from './services/customClients/customClient.service';
import { PrivacyPolicyAfriform } from './pages/public/privacy-policy-afriform/privacy-policy-afriform.component';

import { FunctionDataService } from './services/function/function.data.service';
import { MatTableResponsiveModule } from './shared/mat-table-responsive/mat-table-responsive.module';
import { FunctionResponseServiceService } from './services/function/function.ResponseService.service'
import { ResponseServiceActionsHistoryService } from './services/response-service-actions-history/response-service-actions-history.service';
import { ConfirmationDialogComponent } from './pages/common/confirmation-dialog.component';
import { ClientManagementService } from './services/client-management/client-management.service';
import { ImageService } from './services/image/image.service';
import { SopService } from './services/sop/sop.service';
import { SopComponent } from './pages/admin/admin-pages/client/sop/sop.component';
import { PrivacyPolicySuidpunt } from './pages/public/privacy-policy-suidpunt/privacy-policy-suidpunt.component';
import { ResponderDialogComponent } from './pages/provider/provider-pages/Responders/responder-dialog.component';
import { ImageModalComponent } from 'app/pages/provider/provider-pages/response-service-action/response-service-action/image-modal/image-modal.component';
import { SopDetailsComponent } from 'app/pages/provider/provider-pages/response-service-action/response-service-action/sop-details-model/sop-details.component';

@NgModule({
  exports: [
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    TimezonePickerModule,
  ]
})
export class MaterialModule { }

@NgModule({
  imports: [
    CoreModule,
    CommonModule,
    BrowserAnimationsModule,
    FormsModule,
    RouterModule.forRoot(AppRoutes),
    //HttpModule,
    MaterialModule,
    MatNativeDateModule,
    HttpClientModule,
    FooterModule,
    FixedpluginModule,
    TimezonePickerModule,
    ComponentsModule,
    //AngularFirestoreModule,
    IntercomModule.forRoot({
      appId: 'dbdmmuo7', // from your Intercom config
      updateOnRouterChange: true // will automatically run `update` on router event changes. Default: `false`
    }),
    MatTableResponsiveModule,
    ReactiveFormsModule,
  ],
  declarations: [
    AppComponent,
    PrivacyPolicyWhiteLabel,
    PrivacyPolicyAfriform,
    PrivacyPolicySuidpunt,
    PrivacyPolicyUsa,
    TermsAndConditionsUsa,
    PrivacyPolicy,
    PaymentComponent,
    IntercomComponent,
    PromoCodeComponent,
    GroupShareComponent,
    PaymentCompletedComponent,
    ConfirmationDialogComponent,
    ResponderDialogComponent,
    ImageModalComponent,
    SopDetailsComponent,
  ],
  providers: [
    DateFormatting,
    NumberFormatting,
    ObjectTransformations,
    Globals,
    TablesDotNet,
    DatePipe,
    UploadService,
    GlobalService,
    TwilioService,
    //UserService,
    ResponseServiceActionsHistoryService,
    ExportService,
    FunctionDataService,
    FunctionResponseServiceService,
    LocationService,
    ResponseServiceService,
    ClientService,
    CommunicationService,
    CustomClientService,
    ClientManagementService,
    ImageService,
    SopService
    // { provide: ErrorHandler, useClass: RollbarErrorHandler },
    // { provide: RollbarService, useFactory: rollbarFactory }
  ],
  entryComponents: [
    ConfirmationDialogComponent,
    ResponderDialogComponent,
  ],
  exports: [
    ImageModalComponent,
    SopDetailsComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
